import { render } from "./P030.vue?vue&type=template&id=8780a3b2&scoped=true"
import script from "./P030.vue?vue&type=script&lang=js"
export * from "./P030.vue?vue&type=script&lang=js"

import "./P030.vue?vue&type=style&index=0&id=8780a3b2&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8780a3b2"]])

export default __exports__